import React from 'react';
import { useReveal } from './Reveal';
import ChartNote from './ChartNote';

// Simple, dependency-free comparison bar chart.
// bars: [{ label, value, display, highlight }]
// betterLower: if true the highlighted (metakaolin) bar represents a
// desirable REDUCTION — used only for the caption tone.
const ComparisonChart = ({ caption, unit, bars = [] }) => {
  const { ref, visible } = useReveal({ threshold: 0.25 });
  const max = Math.max(...bars.map((b) => b.value), 1);

  return (
    <div ref={ref} className="rounded-xl border border-slate-200 bg-white p-6 lg:p-7">
      {caption && <p className="text-[13px] font-semibold text-slate-500 mb-5">{caption}</p>}
      <div className="space-y-4">
        {bars.map((b, i) => {
          const pct = visible ? (b.value / max) * 100 : 0;
          return (
            <div key={i}>
              <div className="flex items-center justify-between mb-1.5">
                <span className={`text-[13px] font-semibold ${b.highlight ? 'text-blue-700' : 'text-slate-600'}`}>{b.label}</span>
                <span className={`text-[13px] font-bold ${b.highlight ? 'text-blue-700' : 'text-slate-500'}`}>{b.display}</span>
              </div>
              <div className="h-3 rounded-full bg-slate-100 overflow-hidden">
                <div
                  className={`h-full rounded-full ${b.highlight ? 'bg-blue-600' : 'bg-slate-300'}`}
                  style={{ width: `${pct}%`, transition: 'width 0.9s cubic-bezier(0.22,1,0.36,1)' }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {unit && <p className="mt-5 text-[11.5px] text-slate-400">{unit}</p>}
      <ChartNote />
    </div>
  );
};

export default ComparisonChart;
